
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { partsPropComb } from "@common/src/utils/tools";
import SettlementPrint from "./components/settlement-print.vue";
import ShangHaiPrint from "./components/shanghai-print.vue";
import DelegatePrint from "./components/delegate-print.vue";
import StepList from "@/components/scope/step-list.vue";
import dayjs from "dayjs";
import MissPoint from "./components/miss-print.vue";
import Resettle from "./components/resettle.vue";
import PrintDropdown from "./components/print-dropdown.vue";
import t from "@common/src/i18n/t";
import { mileageRulesEl, checkMoney } from "@common/src/utils/verify";
import InvoiceDropdown from "./components/make-invoice-dropdown.vue";
import { addCurrencySymbol, addCurrencyUnit, permitCountry } from "@common/src/utils/tools";
import CustomerFlag from "@common/src/components/scope/customer-flag/index.vue";
import TextTips from "@common/src/components/scope/text-tips/index.vue";

const app = namespace("app");
const service = namespace("service");
const setting = namespace("setting");
const purchase = namespace("purchase");
const supplier = namespace("supplier");
const parts = namespace("parts");
const common_app = namespace("common_app");
const common_base = namespace("common_base");
const inventory = namespace("inventory");

@Component({
  components: {
    SettlementPrint,
    DelegatePrint,
    StepList,
    MissPoint,
    Resettle,
    ShangHaiPrint,
    InvoiceDropdown,
    CustomerFlag,
    TextTips,
    PrintDropdown
  }
})
export default class ServiceView extends Vue {
  @setting.Getter isManageInventory;
  @service.Action getOrderDetail;
  @service.Action onAccount;
  @service.Action cancleOrder;
  @service.Action completeOrder;
  @inventory.Action queryInventoryAndNotice;
  @service.Action onlineVerificationCode;
  @parts.Action getPartsInventoryList;
  @service.Action getInvoiceInfo;
  @setting.Getter isOpenDispatch;
  @service.Action setAppointmentDate;
  @service.Action getAppointmentCalender;
  @service.Action queryExpress;
  @service.Action receive;
  @service.Action orderConfirm;
  @service.Action requestShipment;
  @service.Action rejection;
  @service.Action modifyCustomerMaintenanceInfo;
  @purchase.Action createQuickPurchase;
  @supplier.Action getSupplierList;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @parts.Action partsInventoryMove;
  @common_app.State country;
  @common_base.State countryStr;
  @service.Action getUri;
  @common_app.State lang;
  @service.Action email;
  @service.Action sms;
  @purchase.Action queryOrderQuickPurchaseList;
  @purchase.Action savePurchase;
  dayjs = dayjs;
  addCurrencySymbol = addCurrencySymbol;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  permitCountry = permitCountry;
  partsPropComb = partsPropComb;
  showInvoiceInfo: boolean = false; // 显示发票信息
  showPickingTips: boolean = false; // 显示领料提示
  showLowStockTips: boolean = false; // 显示低库存提示
  showSelectSupplier: boolean = false; // 显示快速采购 选择供应商
  showStockTransfer: boolean = false; // 显示库存转移
  showSetArriveStoreDate: boolean = false; // 是否显示设置到店时间
  showOrderVaildCode: boolean = false; // 显示输入核销码
  showResettle: boolean = false; //显示退单结算
  receivingDialog: boolean = false;
  logisticsDialog: boolean = false;
  logisticsOrder = "";
  partsList: any[] = [];
  needTransferList: any = [];
  arriveStoreDate: string = dayjs().format("YYYYMMDD"); // 预约到店时间
  verificationCode: string = ""; // 核销码
  emptyToLine = emptyToLine;
  detailData: any = {
    orderStatus: "9",
    photoList: [],
    action: { otherArray: [], mustDoArray: [], optionalArray: [], printArray: [] }
  };
  detailDataPrint: any = {
    orderStatus: "9",
    photoList: [],
    allOrderDetail: { service: [], parts: [], additional: [], receiptData: {} }
  };

  arriveTimeArr: any = [
    ["07", "08"],
    ["08", "09"],
    ["09", "10"],
    ["10", "11"],
    ["11", "12"],
    ["12", "13"],
    ["13", "14"],
    ["14", "15"],
    ["15", "16"],
    ["16", "17"],
    ["17", "18"],
    ["18", "19"],
    ["19", "20"],
    ["20", "21"],
    ["21", "22"]
  ];
  get arriveTimeDisableArr() {
    return this.arriveTimeArr.map(time => {
      return time[0] <= dayjs().get("hour") && this.arriveStoreDate === dayjs().format("YYYYMMDD");
    });
  }
  overflowHidden = true;
  get showLowStockFlag() {
    const show =
      this.isLowStock &&
      this.isManageInventory &&
      (this.detailData.orderStatus === "2" || this.detailData.orderStatus === "5");
    return show;
  }
  chooseTimeIndex: number = -1;
  todayTimeStamp = dayjs().startOf("day").valueOf();
  disableTimeStamp: number = dayjs().add(2, "month").valueOf();
  datePickerOptions: any = {};
  get breadData() {
    return [{ name: t("test.service-management"), path: "/service/index" }, { name: t("service.check-service") }];
  }
  get vehicleArrivalImgs() {
    return this.detailData.photoList.filter(item => item.photoType === 1);
  }
  get vehicleWorkingImgs() {
    return this.detailData.photoList.filter(item => item.photoType === 2);
  }
  get isTH() {
    return this.countryStr === "TH";
  }
  searchParts(val) {
    this.getPartsLists(val);
  }
  getPartsLists(name = "") {
    this.getPartsInventoryList({
      pageNum: 1,
      pageSize: 20,
      searchKey: name
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []);
    });
  }
  getResettleData = false;
  appointmentData: any = [];
  get isRetailOrder() {
    // 是否是零售订单
    return this.detailData.orderType === "3";
  }
  get isTmallOrder() {
    // 是否是天猫订单
    return this.detailData.orderSource === "2";
  }
  get hasAppointmentDate() {
    // 存在的预约时间
    return this.appointmentData.map(item => item.date);
  }
  get isHideTechnician() {
    // 是否隐藏技师
    return this.isOpenDispatch && this.detailData.orderStatus === "2";
  }
  created() {
    this.init();
    this.getAppointmentData();
    this.searchSupplierList();
    this.getPartsLists();
  }
  getAppointmentData() {
    // 获取预约时间日历数据
    this.getAppointmentCalender().then(data => {
      if (data?.data?.list) {
        this.appointmentData = data.data.list;
      }
      this.handleChooseDate(this.arriveStoreDate);
      this.setPickerOptions();
    });
  }
  setPickerOptions() {
    this.datePickerOptions = {
      disabledDate: val => {
        let timestamp = dayjs(val).valueOf();
        return !(timestamp >= this.todayTimeStamp && timestamp <= this.disableTimeStamp);
      },
      cellClassName: val => {
        if (this.hasAppointmentDate.includes(dayjs(val).format("YYYYMMDD"))) {
          return "point";
        }
        return "";
      }
    };
  }
  get orderId() {
    return this.$route.params.id;
  }
  get additionalList() {
    if (!this.detailData.additionalFees) {
      return [];
    }
    return [
      {
        additionalFees: this.detailData.additionalFees,
        additionalFeesRemark: this.detailData.additionalFeesRemark,
        payAdditionalFees: this.detailData.payAdditionalFees
      }
    ];
  }
  dropdownClick(command) {
    if (command === "onAccount") {
      this.onAccount({
        orderNo: this.orderId
      }).then(data => {
        this.$message.success(t("v210831.successful-charge"));
        this.init();
        if (data.data.validateInventoryAlert === "1") {
          const partsCodeList = this.detailData.partsDetail.map(item => item.partsCode);
          if (partsCodeList && partsCodeList.length > 0) {
            this.queryInventoryAndNotice(partsCodeList);
          }
        }
      });
    }
  }
  supplierList: any = [];
  searchSupplierList(val = "") {
    this.getSupplierList({
      pageNum: 1,
      pageSize: 10,
      status: 1,
      searchKey: val
    }).then(data => {
      this.supplierList = this.$safeValue(data, "data.list", []);
    });
  }
  quickPurchasData: any = {
    orderNo: "",
    supplierCode: ""
  };
  quickPurchasDataRules: any = {
    supplierCode: { required: true, message: t("finance.please-select-supplier"), trigger: "blur" }
  };
  handleQuickPurchase() {
    this.quickPurchasData.orderNo = this.orderId;
    (this.$refs.quickPurchaForm as any).validate(valid => {
      if (valid && this.checkPurChaseData()) {
        this.btnStartLoading();
        this.savePurchase(
          Object.assign(this.quickPurchasData, {
            detailList: this.willPurchasePartList,
            quickPurchase: true
          })
        )
          .then(data => {
            this.$message.success(t("v210831.po-created-successfully"));
            this.isLowStock = false;
            this.refreshPartsTableHeader();
            this.showSelectSupplier = false;
            const { href } = this.$router.resolve(`/purchase/purchase-view/${data.data.purchaseNo}`);
            window.open(href);
          })
          .finally(() => {
            this.btnStopLoading();
          });
      }
    });
  }
  checkPurChaseData() {
    const check = this.willPurchasePartList.some(parts => !checkMoney(parts.costPrice).success);
    if (check) {
      this.$message.error(t("v213.please-enter-the-purchase-unit-price-decimal-places"));
      return false;
    }
    return true;
  }
  handleStockTransfer() {
    if (!this.needTransferList.some(item => item.basePartsCode)) {
      return this.$message.error(t("v210831.please-select-the-has-stock-parts"));
    }
    this.btnStartLoading();
    let params = {
      movePartsArray: this.needTransferList.filter(item => item.basePartsCode)
    };
    this.partsInventoryMove(params)
      .then(() => {
        this.$message.success(t("v210831.the-inventory-migration"));
        this.isLowStock = false;
        this.refreshPartsTableHeader();
        this.showStockTransfer = false;
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  invoiceInfo: any = {};
  handleShowInvoice() {
    this.getInvoiceInfo({
      orderNo: this.orderId
    }).then(data => {
      this.invoiceInfo = data.data;
      this.showInvoiceInfo = true;
    });
  }
  handleLinkEdit() {
    if (this.isRetailOrder) {
      this.$router.push(`/service/retail/edit/${this.orderId}`);
    } else {
      this.$router.push(`/service/edit/${this.orderId}`);
    }
  }
  willPurchasePartList: any = [];
  handleShowSupplier() {
    this.queryOrderQuickPurchaseList({
      orderNo: this.orderId
    }).then(data => {
      this.willPurchasePartList = data.data?.list || [];
    });
    this.showSelectSupplier = true;
  }
  handleChooseTime(i, disable) {
    if (disable) return;
    this.chooseTimeIndex = i;
  }
  handleLinkVehicleInfo() {
    let { href } = this.$router.resolve({
      path: `/setting/customer-view/${this.detailData.customerCode}?vehicleCode=${this.detailData.vehicleCode}`
    });
    window.open(href, "_blank");
  }
  handleLinkOpenCard() {
    const { href } = this.$router.resolve(`/marketing/card-open?customerCode=${this.detailData.customerCode}`);
    window.open(href);
  }
  handleLinkReceipt(orderData) {
    let { href } = this.$router.resolve({
      path: `/finance/collection-order-view/${orderData.receiptNo}`
    });
    window.open(href, "_blank");
  }
  handleLinkOutboundView(outboundNo) {
    let { href } = this.$router.resolve({
      path: `/inventory/out-warehouse-view/${outboundNo}`
    });
    window.open(href, "_blank");
  }
  handleLinkPerfect() {
    let { href } = this.$router.resolve({
      path: `/setting/customer-edit/${this.detailData.customerCode}?vehicleCode=${this.detailData.vehicleCode}&fromOrderNo=${this.orderId}`
    });
    window.open(href, "_blank");
  }
  handleInvoice() {
    this.$router.push(`/service/make-invoice/${this.orderId}`);
  }
  handleRequestShipment() {
    this.btnStartLoading();
    this.requestShipment({ orderNo: this.orderId })
      .then(() => {
        this.$message.success(t("base.success") as string);
        this.init();
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  handleRejectOrder() {
    this.$confirm(t("service.confirm-reject-order") as string, t("v210831.tips") as string, {
      confirmButtonText: t("v210831.determine") as string,
      cancelButtonText: t("base.cancel") as string,
      type: "warning"
    })
      .then(() => {
        this.btnStartLoading();
        this.rejection({ orderNo: this.orderId })
          .then(() => {
            this.$message.success(t("base.success") as string);
            this.init();
          })
          .finally(() => {
            this.btnStopLoading();
          });
      })
      .catch(() => {
        //
      });
  }
  handleComplete() {
    this.btnStartLoading();
    this.completeOrder({
      orderNo: this.orderId
    })
      .then(
        data => {
          if (data.data.validateInventoryAlert === "1") {
            const partsCodeList = this.detailData.partsDetail.map(item => item.partsCode);
            if (partsCodeList && partsCodeList.length > 0) {
              this.queryInventoryAndNotice(partsCodeList);
            }
          }
          this.$message.success(t("base.success") as string);
          this.init();
        },
        data => {
          if (data.code === "speedbiz.order.order-status-not-match") {
            this.showPickingTips = true;
          } else {
            this.$message.error(data.message);
          }
        }
      )
      .finally(() => {
        this.btnStopLoading();
      });
  }
  handleVerification() {
    this.showOrderVaildCode = true;
  }
  handleResettle() {
    this.showResettle = false;
    this.$message.success(t("v210831.chargeback-settlement-succeeded"));
    this.init();
  }
  handlePicking() {
    this.$router.push(`/inventory/out-warehouse-view/${this.detailData.outboundNo}`);
  }
  handleArriveStore() {
    if (this.detailData.processType === "TMALL") {
      this.$router.push(`/service/arrive/input/${this.detailData.orderNo}`);
    } else {
      this.$router.push(`/service/edit/${this.detailData.orderNo}?pageType=arrive`);
    }
  }
  handleDispatch() {
    let { href } = this.$router.resolve({
      path: `/service/dispatch-worker/index`
    });
    window.open(href, "_blank");
  }
  handleVerificationCode() {
    if (!this.verificationCode) {
      this.$message.error(t("service.please-senter-verification-code"));
      return;
    }
    this.btnStartLoading();
    this.onlineVerificationCode({
      orderNo: this.orderId,
      verificationCode: this.verificationCode
    })
      .then(data => {
        this.showOrderVaildCode = false;
        this.init();
        this.$message.success(`${t("service.order")}“${this.orderId}”${t("test.have-been-completed")}`);
        if (data.data.validateInventoryAlert === "1") {
          const partsCodeList = this.detailData.partsDetail.map(item => item.partsCode);
          if (partsCodeList && partsCodeList.length > 0) {
            this.queryInventoryAndNotice(partsCodeList);
          }
        }
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  handleSettlement() {
    this.$router.push(`/service/cashier/${this.orderId}`);
  }
  groupIndex: number = 1;
  refreshTable: boolean = true;
  isLowStock: boolean = false;
  refreshPartsTableHeader() {
    this.refreshTable = false;
    this.$nextTick(() => {
      this.refreshTable = true;
    });
  }
  init() {
    this.getOrderDetail({
      orderNo: this.orderId
    }).then(data => {
      data.data.customerOilVolume = Number(data?.data?.customerOilVolume || 0);
      const serviceCodeMap = {}; // 存放service和parts索引映射关系
      const partsStockMap = {}; // 存放零配件的数量，合并相同零配件行
      data.data.partsDetail.forEach((parts, index) => {
        if (parts.serviceCode) {
          if (serviceCodeMap[parts.serviceCode]) {
            serviceCodeMap[parts.serviceCode].push(index);
          } else {
            serviceCodeMap[parts.serviceCode] = [index];
          }
        }
        const curPartsNum = partsStockMap[parts.partsCode];
        if (curPartsNum === undefined) {
          partsStockMap[parts.partsCode] = Number(parts.quantity);
        } else {
          partsStockMap[parts.partsCode] = curPartsNum + Number(parts.quantity);
        }
        if (partsStockMap[parts.partsCode] > Number(parts.invQty)) {
          this.isLowStock = true;
          setTimeout(() => {
            this.showLowStockTips = true;
          });
        }
        if (Number(parts.invQty) === 0) {
          this.needTransferList.push(Object.assign(parts, { basePartsCode: "", targetPartsCode: parts.partsCode }));
        }
      });
      data.data.serviceDetail.forEach(serviceItem => {
        if (serviceCodeMap[serviceItem.serviceCode]) {
          serviceItem.isGroup = true;
          serviceItem.groupServiceIndex = this.groupIndex;
          serviceCodeMap[serviceItem.serviceCode].forEach(i => {
            data.data.partsDetail[i].isGroup = true;
            data.data.partsDetail[i].groupServiceIndex = this.groupIndex;
          });
          this.groupIndex++;
        }
      });
      this.detailData = data.data;
      this.detailDataPrint = data.data;
      this.isResettleFn();
      // 处理在小屏幕上零配件表格出现横向滚动条出现当前库存数定位不准的问题
      setTimeout(() => {
        this.overflowHidden = false;
      }, 200);
    });
  }
  // 是否支持退单结算
  isResettle: boolean = false;
  isResettleFn() {
    // 后端判断退单结算是否显示
    let isShow = this.detailData.action.otherArray.includes("ORDER_RETURN");
    if (isShow) {
      this.isResettle = true;
    } else {
      this.isResettle = false;
    }
    // 处理退单结算信息数据
    if (this.detailData.settlementStatus === "3") {
      if (!this.detailData.returnPayment) {
        this.detailData.returnPayment = {};
      }
      let resettleItem = this.detailData.orderLogger.find(
        v => v.desc === t("v210831.chargeback-settlement") || v.desc === t("v210831.order-de-settlement")
      );
      this.detailData.returnPayment["createUserName"] = resettleItem.createUserName;
      this.detailData.returnPayment["paidTime"] = resettleItem.createTime;
      if (this.detailData.returnPayment["remark"]) {
        let remark = this.detailData.returnPayment["remark"];
        remark = remark.split(" ");
        remark.pop();
        remark = remark.join("");
        this.detailData.returnPayment["remark"] = remark;
      }
    }
  }
  todayAppointmentData: any = {};
  handleChooseDate(val) {
    this.chooseTimeIndex = -1; // 切换日期清空时间段选择
    this.todayAppointmentData = {};
    let thisDay = this.appointmentData.find(item => {
      return item.date === val;
    });
    if (thisDay) {
      let temp = {};
      thisDay.reservationHours.forEach(item => {
        temp[item.hour] = item.reservationOrderCount;
      });
      this.todayAppointmentData = temp;
    }
  }
  logisticsDialogInit = false;
  handleMoreMenuClick(command) {
    if (command === "cancel") {
      this.cancleOrder({
        orderNo: this.orderId
      }).then(() => {
        this.$message.success(t("base.success") as string);
        this.init();
      });
    } else if (command === "newCheck") {
      let { href } = this.$router.resolve({
        path: `/test/add?customerCode=${this.detailData.customerCode}&vehicleCode=${this.detailData.vehicleCode || ""}`
      });
      window.open(href, "_blank");
    } else if (command === "resettle") {
      this.showResettle = true;
      this.getResettleData = true;
    } else if (command === "sureReceiving") {
      this.receivingDialog = true;
    } else if (command === "lookLogistics") {
      this.queryExpressFn();
    } else if (command === "confirm") {
      this.handleConfirm();
    } else if (command === "requestShipment") {
      this.handleRequestShipment();
    } else if (command === "rejectOrder") {
      this.handleRejectOrder();
    } else {
      // 新建订单
      if (command === "retail") {
        this.$router.push(
          `/service/retail/add?customerCode=${this.detailData.customerCode}&vehicleCode=${
            this.detailData.vehicleCode || ""
          }`
        );
      } else {
        this.$router.push(
          `/service/add?type=${command}&customerCode=${this.detailData.customerCode}&vehicleCode=${
            this.detailData.vehicleCode || ""
          }`
        );
      }
    }
  }
  expressObj = {
    expressCompanyDesc: "",
    deliveryDetail: []
  };
  handleConfirm() {
    this.orderConfirm({
      orderNo: this.orderId
    }).then(() => {
      this.$message.success(t("v211030.order-confirmed"));
      this.init();
    });
  }
  queryExpressFn() {
    this.queryExpress({ orderNo: this.orderId }).then(data => {
      if (data.data) {
        this.logisticsDialog = true;
        this.logisticsDialogInit = true;
        this.expressObj = data.data;
        this.logisticsOrder = data.data.expressNo;
      } else {
        this.$message.warning(t("v211030.no-logistics-information"));
      }
    });
  }
  receiveFn() {
    this.receive({ orderNo: this.orderId }).then(data => {
      if (data.code === "0") {
        this.$message.success(t("v211030.confirm-receipt-succeeded"));
      } else {
        this.$message.success(t("v211030.failed-to-confirm-receipt"));
      }
    });
  }
  handleAppointment() {
    if (!this.arriveStoreDate || this.chooseTimeIndex < 0) {
      return this.$message.error(t("service.choose-your-arrival-time"));
    }
    this.showSetArriveStoreDate = false;
    this.setAppointmentDate({
      orderNo: this.orderId,
      reservationArrivalTime: this.arriveStoreDate + this.arriveTimeArr[this.chooseTimeIndex][0]
    }).then(() => {
      this.$message.success(`${t("service.order")}“${this.orderId}”${t("service.arrival-time-has-been-set")}`);
      this.init(); // 获取订单详情
      this.getAppointmentData(); // 获取预约时间数据
    });
  }
  handleReceivingDialog() {
    this.receiveFn();
    this.receivingDialog = false;
  }
  onCopy() {
    // alert("You just copied: " + e.text);
    this.$message.success(t("v210831.copy-succeeded"));
  }
  onError(e) {
    console.log(e);
  }
  handleShowLowStock() {
    document.querySelector(".page-service-view").scrollTo(0, 800);
  }
  handleCommand(command) {
    // 马来版本发票发送
    if (command === "Email") {
      this.email({ orderNo: this.orderId }).then(res => {
        if (res.code === "0") {
          this.$message.success(t("v210831.sent-successfully"));
        }
      });
    } else if (command === "SMS") {
      this.sms({ orderNo: this.orderId }).then(res => {
        if (res.code === "0") {
          this.$message.success(t("v210831.sent-successfully"));
        }
      });
    } else if (command === "Print") {
      this.getUri({ orderNo: this.orderId }).then(res => {
        if (res.code === "0") {
          window.open(res.data);
        }
      });
    } else if (command === "Share") {
      this.getUri({ orderNo: this.orderId }).then(res => {
        if (res.code === "0") {
          this.$copyText(res.data).then(() => this.$message.success(t("v210831.copy-succeeded")));
        }
      });
    }
  }
  showModifyMileagePop: boolean = false;
  mileageFormData: any = {
    orderNo: "",
    customerCurrentMileage: "",
    customerNextMileage: "",
    customerNextMaintenanceDate: ""
  };
  mileageFormDataRules: any = {
    customerCurrentMileage: { validator: this.checkMileage, trigger: "change" },
    customerNextMileage: { validator: this.checkMileage, trigger: "change" }
  };
  checkMileage(rule, value, callback) {
    mileageRulesEl(value, callback, true);
  }
  handleShowModifyMileage() {
    this.showModifyMileagePop = true;
    this.mileageFormData.customerCurrentMileage = this.detailData.customerCurrentMileage || "";
    this.mileageFormData.customerNextMileage = this.detailData.customerNextMileage || "";
    this.mileageFormData.customerNextMaintenanceDate = this.detailData.customerNextMaintenanceDate
      ? dayjs(this.detailData.customerNextMaintenanceDate).format("YYYYMMDD")
      : "";
  }
  handleSaveMileageInfo() {
    (this.$refs.mileageForm as any).validate(valid => {
      if (valid) {
        this.mileageFormData.orderNo = this.orderId;
        this.btnStartLoading();
        this.modifyCustomerMaintenanceInfo(this.mileageFormData)
          .then(() => {
            this.$message.success(t("v210831.saved-successfully"));
            this.showModifyMileagePop = false;
            this.init();
          })
          .finally(() => {
            this.btnStopLoading();
          });
      }
    });
  }
  showTaxDetailDialog = false;
  openTaxDetail() {
    this.showTaxDetailDialog = true;
  }
}
